<template>
  <div class="addNewClass" >
    <div class="content">
      <div class="header" style= "font-size: 20px;margin-bottom: 10px">
        设置 :
      </div>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" bg-purple name">
            <span>帖子排序方式</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-radio-group v-model="radio">
            <el-radio label="3">发帖时间</el-radio>
            <el-radio label="6">回帖时间</el-radio>
            <el-radio label="9">评论数</el-radio>
            <el-radio label="9">阅读数</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" bg-purple name">
            <span>热门设置</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class=" bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <div class="flex">
                  阅读超过<input oninput="if(value  <= 0 ){value = 0}" v-model="form.stock" type="number" class="radioInput">
                  阅读
                </div>
                <div class="flex">
                  评论超过<input oninput="if(value  <= 0 ){value = 0}" type="number" v-model="form.up_limit" class="radioInput">条
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" bg-purple name">
            <span>无图文章默认图片</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class=" bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <el-upload
                  ref="upload"
                  list-type="picture-card"
                  action="#"
                  :http-request="(file)=> { return productUploadImg(file) }"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :file-list="fileListData"
                  :limit="3"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" bg-purple name">
            <span>手动选择</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class=" bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <el-select v-model="form.region" placeholder="请选择" size="small">
                  <el-option label="1" value="shanghai"></el-option>
                  <el-option label="2" value="beijing"></el-option>
                </el-select>
                
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div class="submit" style = "margin-top: 70px;">
        <el-button type="primary">提交</el-button>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { addCoupon, editcoupon, detailcoupon } from "@/api/coupon";
import { vipList } from "@/api/vip";
import { getCateApi, addImage } from "@/api/mall";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
  },
  components: {
  },
  data() {
    return {
      imgdata: {},
      imageUrl: "",
      imageIdx: 0,
      fileListData:[], //filelist列表
      dialogImageUrl: "", // 上传商品图片
      dialogVisible: false,
      chosepictireid:[], //已上传图片id数组暂存
      radio: "3",
      form: {
        title: "",
        sub_title: "",
        stock: "", //
        up_limit: "", //
        address: "", //
        mobile: "", //
        is_list_show: "1"
      },
    };
  },
  methods:{
    // 商品图片
    handleRemove(file) {
      //  图片删除同步更改列表
      var replaceArr = this.fakefileList;
      for(var i= 0; i < replaceArr.length; i++){
        if(file.uid == replaceArr[i].uid){
          replaceArr.splice(i,1);
          this.chosepictireid.splice(i,1);
          this.dataArray.goods.image_id = this.chosepictireid.join(',');
          console.log(this.dataArray.goods.image_id,"dffffffff");
          break;
        }
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
    },
    // 图片
    productUploadImg(file){
      var that = this;
      var formdata = new FormData();
      formdata.append('token', that.token);
      formdata.append('image', file.file);
      formdata.append('type', "1");
      formdata.append('file_group', "1");
      addImage(formdata).then(res => {
        console.log("上传回调",res);
        var data = res.data;
        if(res.code == 200){
          this.chosepictireid.push(res.data.id);
          this.dataArray.goods.image_id = this.chosepictireid.join(',');
          var list = {};
          var index = 0;
          list.name = res.data.key;
          list.url = res.data.url;
          // 图片列表
          this.fakefileList.push(list);
        } else{
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  }
};
</script>

<style lang="scss" scoped>
.flex{
  display: flex;
  justify-content: flex-start;
  padding: 5px 0;
}
.color{
  color: #606266;
  font-size: 10px;
}

.radioInput {
  height: 28px;
  margin: 0 5px;
  width: 60px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}
.radioInputM {
  height: 28px;
  margin-right: 5px;
  width: 60px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}
.marginR{
  margin-right: 5px;
}
.marginRL {
  margin: 0 5px;
}
.marginSX {
  margin: 10px 0;
}
  .avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #DCDFE6;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    overflow: auto;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 20px 30px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
      font-size: 14px;
    }
    
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>

<style lang="scss">
.addNewClass {
  .editor {
    width: 100%;
    .text {
      min-height: 220px;
    }
  }
}
</style>
